import { useState } from "react"
import { handleApi } from "../../apis";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

/**
 * Custom hook to return function of get, accept, reject and update order
 * @returns function, order and loading state
 */

const useGetUpdateOrder = () => {

    const [order, setOrder] = useState({});
    const navigate = useNavigate();
    /**
     * Get, accept, reject and update order
     */

    const handleOrder = (endpoint, params, refresh) => {
        return new Promise((resolve, reject) => {
            handleApi(endpoint, params,null,navigate).then(res => {
                const { order } = res || {};

                refresh && setOrder(order);
                resolve();
            }).catch(err => {
                toast.error(err?.response?.data?.message || "Something went wrong", {className:'errorToast'})
                reject(err);
            });
        })
    }

    const handleBulkOrder = (endpoint, params, refresh) => {
        return new Promise((resolve, reject) => {
            handleApi(endpoint, params,null,navigate).then(res => {
                resolve();
            }).catch(err => {
                toast.error(err?.response?.data?.message || "Something went wrong", {className:'errorToast'})
                reject(err);
            });
        })
    }

    return { handleOrder, handleBulkOrder, setOrder, order };
}

export default useGetUpdateOrder;